import React, { useState } from 'react';
import Pagination from '../../Common/Pagination';

export default function SiteRainLogsHourly({ logTypeName, logs, hide, onPrint }) {
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });
    const dateHourFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });
    const [isClosed, setIsClosed] = useState(false);
    const [selectedPage, setSelectedPage] = useState(1);
    const defaultPageSize = 30;
    const [pageSize, setPageSize] = useState(defaultPageSize);

    function handleSelectPage(pageNum) {
        setSelectedPage(pageNum);
    }

    let noItems = logs?.length === 0 && (<div className="centeredMessage"><h5>No Rain Logs available.</h5></div>);

    let shownLogs = logs.slice((pageSize * selectedPage) - pageSize, (pageSize * selectedPage));
    let shownStartIndex = (pageSize * selectedPage) - pageSize;
    let shownEndIndex = (pageSize * selectedPage);

    let logListItems = !isClosed && logs && logs
        .map((log, index) => <tr className={index < shownStartIndex || index >= shownEndIndex ? "hidden" : ""} key={log.id}>
            <td className="tabular-nums">{log.eventTime && dateHourFormatter.format(new Date(log.eventTime))}</td>
            <td>{log.rainfallTotal}</td>
            <td>{log.stormAmount}</td>
            <td className="smallScreen">
                <div className="log">
                    {log.eventTime && (<div>
                        <span className="fieldDesc">Time:</span>
                        <span className="whitespace-nowrap">{log.eventTime && dateHourFormatter.format(new Date(log.eventTime))}</span>
                    </div>)}
                    {log.rainfallTotal !== undefined && (<div>
                        <span className="fieldDesc">1-hr Rainfall Total(in.):</span>
                        {log.rainfallTotal}
                    </div>)}
                    {log.stormAmount !== undefined && (<div>
                        <span className="fieldDesc">Storm Total(in.):</span>
                        {log.stormAmount}
                    </div>)}
                </div>
            </td>
        </tr>);

    if (selectedPage > 1 && (pageSize * selectedPage) - logListItems.length > 0) {
        let emptyRows = Array.from(
            { length: (pageSize * selectedPage) - logListItems.length },
            (cv, i) => (<tr className="noBkg noPrint" key={`R${i}`}><td>&nbsp;</td></tr>));
        logListItems = logListItems.concat(emptyRows);
    }

    let printButton = (<button onClick={() => onPrint("Rain Logs", "#rainLogs")}>Print</button>);

    let logList = logListItems.length === 0 ? undefined : !isClosed &&
        (<>
            <table id="rainLogs" className="itemList">
                <thead>
                    <tr>
                        <th className="date">Time</th>
                        <th className="date">1-hr Rainfall Total(in.)</th>
                        <th className="date">Storm Total(in.)</th>
                    </tr>
                </thead>
                <tbody>{logListItems}</tbody>
            </table>
            <Pagination itemCount={logs.length} pageSize={pageSize} selectedPage={selectedPage} hideWhenSinglePage={false} onSelectPage={handleSelectPage}>
                {printButton}
            </Pagination>
        </>);

    //let selectLogType = onSelectLogType && (<span className="select" onClick={() => onSelectLogType()}><i className={logTypeSelected ? "dhicon-check-2" : "dhicon-check-empty"} /></span>);
    let selectLogType;

    let iconClass = isClosed ? "dhicon-right-open-2" : "dhicon-down-open-4";
    //let openClose = (<i className={`icon ${iconClass}`} onClick={() => setIsClosed(!isClosed)} />);
    let openClose;

    let showAllOption = //logs?.length > defaultPageSize &&
        (<option value={logs.length}>All</option>);
    let showFilter = logs?.length > 0 && (<div className="text-base content-end">
        <span>Show</span>
        <select className="bg-drhPalette-light mx-1 pl-1" onChange={(e) => setPageSize(e.target.value)} value={pageSize}>
            <option value={defaultPageSize}>{defaultPageSize}</option>
            {showAllOption}
        </select>
        <span>entries</span>
    </div>);

    let logTypeNameDescription = (<div className="text-drhPalette-primary text-xl font-bold pt-3 pb-1 flex justify-between">
        <span>{logTypeName}</span>
        {showFilter}
    </div>);

    let hideClass = hide && "hidden"

    return (
        <div className={`logTypeContainer rainLogs ${hideClass}`}>
            {logTypeNameDescription}
            {logList}
            {noItems}
        </div>
    );
}